const EXACT_PUBLIC_ROUTES = [
  "/",
  "/login",
  "/register",
  "/recuperar-senha",
  "/redefinir-senha",
] as const;

const PUBLIC_ROUTE_PREFIXES = ["/agendar", "/home"] as const;

/** Normaliza pathname removendo query string e barra final (exceto raiz). */
export function normalizePathname(pathname: string): string {
  const withoutQuery = pathname.split("?")[0] ?? pathname;
  if (withoutQuery === "/") return "/";
  return withoutQuery.replace(/\/$/, "") || "/";
}

/** Rotas acessíveis sem autenticação (match exato ou prefixo). */
export function isPublicRoute(pathname: string): boolean {
  const path = normalizePathname(pathname);

  if ((EXACT_PUBLIC_ROUTES as readonly string[]).includes(path)) {
    return true;
  }

  return PUBLIC_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}

/**
 * Indica se um 401 deve ser tratado como visitante anônimo (sem signOut/redirect).
 * Em rota pública, ausência de sessão é estado normal — não é sessão expirada.
 */
export function shouldTreat401AsAnonymous(pathname: string): boolean {
  return isPublicRoute(pathname);
}
